import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';

import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect } from 'react';

class LanguageSelectStore {
  @observable isOpen = false;
  @observable languageSelected = '';
  @observable languageList = [];

  onLanguageBtnClick = () => {
    if (!this.languageList.length) return;
    this.isOpen = !this.isOpen;
  };
  onLanguageSelected = index => {
    const item = this.languageList[index];
    const selected = item.language === this.languageSelected;
    if (!selected && item.website_link) {
      window.location.href = item.website_link;
    } else {
      this.isOpen = false;
    }
  };

  checkParentId = (element, mark) => {
    const parent = element.parentNode;
    if (!parent) {
      return false;
    }
    const elementId = parent.id;
    if (elementId === mark) {
      return true;
    } else {
      return this.checkParentId(parent, mark);
    }
  };

  fallbackLanguages = [
    {
      language: '简体中文',
      website_link: '//job.seasungames.cn/index.html'
    },
    {
      language: 'English',
      website_link: '//job.seasungames.com/index/index.html'
    }
  ];

  fallbackLanguage = window.location.hostname.includes('.cn') ? '简体中文' : 'English';

  useLanguage() {
    const languages = useLayerData('languages');
    const { language } = useLayerData('pageConfig', {});

    useEffect(
      () => {
        this.languageList = languages || this.fallbackLanguages;
        this.languageSelected = language || this.fallbackLanguage;
      },
      [languages, language]
    );
  }

  use() {
    this.useLanguage();

    useMount(async () => {
      const hideExpandList = e => {
        if (!this.checkParentId(e.target, 'languageContainer')) {
          this.isOpen = false;
        }
      };
      window.addEventListener('click', hideExpandList, false);
      return () => {
        window.removeEventListener('click', hideExpandList, false);
      };
    });
  }
}

export default LanguageSelectStore;
